import { render } from "./DriverContactUs.vue?vue&type=template&id=2d67e15e"
import script from "./DriverContactUs.vue?vue&type=script&lang=js"
export * from "./DriverContactUs.vue?vue&type=script&lang=js"
script.render = render

export default script